import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WidgetService } from '../shared/services/widgets.service';

@Component({
  selector: 'app-notify-component',
  templateUrl: './notify-component.component.html',
  styleUrls: ['./notify-component.component.scss']
})
export class NotifyComponentComponent implements OnInit {

  lazyReportsInfo = []

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NotifyComponentComponent>,
    private dialog: MatDialog,
    private widgetService: WidgetService) { }

  ngOnInit(): void {
    this.lazyReportsInfo = this.data.lazyReportsInfo;
  }

  close(): void {
    // this.dialog.closeAll();
    this.dialogRef.close(this.lazyReportsInfo);
  }

  handleStatusReport(status): string {
    switch (status) {
      case '0':
        return 'Pendente';
      case '1':
        return 'Baixar';
    }
  }
  handlePeriod(period): string {
    return `período ${period.replace('|', 'à')}`
  }

  removeCard(reportLazy, index: number) {

    this.widgetService.removeLazyReportProcess(reportLazy.idProcess, this.data.personId).then((res) => {
      this.lazyReportsInfo = res.body;
    })
  }

  downloadFile(reportLazy) {
    
    const link = document.createElement('a');
    link.href = `${reportLazy.reportUrl}`;
    link.download = `${reportLazy.reportName}.csv`;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    this.removeNotification(reportLazy);
  }

  removeNotification(reportLazy) {
    this.widgetService.setDownloadedLazyReportProcess(reportLazy.idProcess, this.data.personId).then((res) => {
      this.lazyReportsInfo = res;
    })

  }

}
